/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createDeliveryMethod } from '../fn/delivery-methods/create-delivery-method';
import { CreateDeliveryMethod$Params } from '../fn/delivery-methods/create-delivery-method';
import { deleteDeliveryMethods } from '../fn/delivery-methods/delete-delivery-methods';
import { DeleteDeliveryMethods$Params } from '../fn/delivery-methods/delete-delivery-methods';
import { DeliveryMethodCreateResponse } from '../models/delivery-method-create-response';
import { DeliveryMethodDetailedResponse } from '../models/delivery-method-detailed-response';
import { getAllZipCodes } from '../fn/delivery-methods/get-all-zip-codes';
import { GetAllZipCodes$Params } from '../fn/delivery-methods/get-all-zip-codes';
import { getDeliveryMethod } from '../fn/delivery-methods/get-delivery-method';
import { GetDeliveryMethod$Params } from '../fn/delivery-methods/get-delivery-method';
import { getDeliveryMethods } from '../fn/delivery-methods/get-delivery-methods';
import { GetDeliveryMethods$Params } from '../fn/delivery-methods/get-delivery-methods';
import { PageDeliveryMethodPageResponse } from '../models/page-delivery-method-page-response';
import { RegionCityWithZipCodeResponse } from '../models/region-city-with-zip-code-response';
import { updateDeliveryMethod } from '../fn/delivery-methods/update-delivery-method';
import { UpdateDeliveryMethod$Params } from '../fn/delivery-methods/update-delivery-method';
import { updateSitesOfDeliveryMethod } from '../fn/delivery-methods/update-sites-of-delivery-method';
import { UpdateSitesOfDeliveryMethod$Params } from '../fn/delivery-methods/update-sites-of-delivery-method';


/**
 * Delivery method resource endpoints.
 */
@Injectable({ providedIn: 'root' })
export class DeliveryMethodsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getDeliveryMethod()` */
  static readonly GetDeliveryMethodPath = '/delivery/methods/{deliveryMethodId}';

  /**
   * Gets delivery method.
   *
   * Finds and returns the saved resource with the specified id.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDeliveryMethod()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeliveryMethod$Response(params: GetDeliveryMethod$Params, context?: HttpContext): Observable<StrictHttpResponse<DeliveryMethodDetailedResponse>> {
    const obs = getDeliveryMethod(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets delivery method.
   *
   * Finds and returns the saved resource with the specified id.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDeliveryMethod$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeliveryMethod(params: GetDeliveryMethod$Params, context?: HttpContext): Observable<DeliveryMethodDetailedResponse> {
    const resp = this.getDeliveryMethod$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DeliveryMethodDetailedResponse>): DeliveryMethodDetailedResponse => r.body)
    );
  }

  /** Path part for operation `updateDeliveryMethod()` */
  static readonly UpdateDeliveryMethodPath = '/delivery/methods/{deliveryMethodId}';

  /**
   * Updates a delivery method.
   *
   * Updates an existing delivery method based on its identifier.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateDeliveryMethod()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDeliveryMethod$Response(params: UpdateDeliveryMethod$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = updateDeliveryMethod(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates a delivery method.
   *
   * Updates an existing delivery method based on its identifier.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateDeliveryMethod$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDeliveryMethod(params: UpdateDeliveryMethod$Params, context?: HttpContext): Observable<void> {
    const resp = this.updateDeliveryMethod$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateSitesOfDeliveryMethod()` */
  static readonly UpdateSitesOfDeliveryMethodPath = '/delivery/methods/{deliveryMethodId}/sites';

  /**
   * Updates sites of a delivery method.
   *
   * Updates sites of an existing delivery method based on its identifier.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSitesOfDeliveryMethod()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSitesOfDeliveryMethod$Response(params: UpdateSitesOfDeliveryMethod$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = updateSitesOfDeliveryMethod(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates sites of a delivery method.
   *
   * Updates sites of an existing delivery method based on its identifier.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSitesOfDeliveryMethod$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSitesOfDeliveryMethod(params: UpdateSitesOfDeliveryMethod$Params, context?: HttpContext): Observable<void> {
    const resp = this.updateSitesOfDeliveryMethod$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getDeliveryMethods()` */
  static readonly GetDeliveryMethodsPath = '/delivery/methods';

  /**
   * Lists delivery methods.
   *
   * Returns a paginated list of delivery methods. Accessible to all authenticated users (no specific role required).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDeliveryMethods()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeliveryMethods$Response(params?: GetDeliveryMethods$Params, context?: HttpContext): Observable<StrictHttpResponse<PageDeliveryMethodPageResponse>> {
    const obs = getDeliveryMethods(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Lists delivery methods.
   *
   * Returns a paginated list of delivery methods. Accessible to all authenticated users (no specific role required).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDeliveryMethods$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeliveryMethods(params?: GetDeliveryMethods$Params, context?: HttpContext): Observable<PageDeliveryMethodPageResponse> {
    const resp = this.getDeliveryMethods$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PageDeliveryMethodPageResponse>): PageDeliveryMethodPageResponse => r.body)
    );
  }

  /** Path part for operation `createDeliveryMethod()` */
  static readonly CreateDeliveryMethodPath = '/delivery/methods';

  /**
   * Creates a new delivery method.
   *
   * Creates a new deliveryMethod and returns the saved resource with its identifier.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createDeliveryMethod()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDeliveryMethod$Response(params: CreateDeliveryMethod$Params, context?: HttpContext): Observable<StrictHttpResponse<DeliveryMethodCreateResponse>> {
    const obs = createDeliveryMethod(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates a new delivery method.
   *
   * Creates a new deliveryMethod and returns the saved resource with its identifier.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createDeliveryMethod$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDeliveryMethod(params: CreateDeliveryMethod$Params, context?: HttpContext): Observable<DeliveryMethodCreateResponse> {
    const resp = this.createDeliveryMethod$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DeliveryMethodCreateResponse>): DeliveryMethodCreateResponse => r.body)
    );
  }

  /** Path part for operation `getAllZipCodes()` */
  static readonly GetAllZipCodesPath = '/delivery/methods/zip-codes';

  /**
   * Gets all regions' all zip codes.
   *
   * Returns all regions' and all there zips.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllZipCodes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllZipCodes$Response(params?: GetAllZipCodes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RegionCityWithZipCodeResponse>>> {
    const obs = getAllZipCodes(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets all regions' all zip codes.
   *
   * Returns all regions' and all there zips.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllZipCodes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllZipCodes(params?: GetAllZipCodes$Params, context?: HttpContext): Observable<Array<RegionCityWithZipCodeResponse>> {
    const resp = this.getAllZipCodes$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<RegionCityWithZipCodeResponse>>): Array<RegionCityWithZipCodeResponse> => r.body)
    );
  }

  /** Path part for operation `deleteDeliveryMethods()` */
  static readonly DeleteDeliveryMethodsPath = '/delivery/methods/selected';

  /**
   * Delete a delivery method.
   *
   * Delete a delivery method by its identifier
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteDeliveryMethods()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDeliveryMethods$Response(params: DeleteDeliveryMethods$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteDeliveryMethods(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a delivery method.
   *
   * Delete a delivery method by its identifier
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteDeliveryMethods$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDeliveryMethods(params: DeleteDeliveryMethods$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteDeliveryMethods$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
